<template>
  <div>
    <div class="v-page-header">
      <header-group />
      <!--			<div class="work-name">{{ workDetail.name }}</div>-->
      <div class="header-right">
        <div class="setting-box">
          <template
            v-if="
              (worksType == 3 && groupList[0] && groupList[0].id == activeGroupId) || worksType == 1
            "
          >
            <div
              class="setting-btn"
              :class="{ active: isShowSpotList }"
              @click="showPanel('isShowSpotList')"
            >
              热点
            </div>
            <div class="setting-btn" :class="{ active: isFloorSpot }" @click="openFloorSpot">
              添加地板热点
            </div>
            <div
              class="setting-btn"
              :class="{ active: isShowPolylineList }"
              @click="showPanel('isShowPolylineList')"
            >
              折线
            </div>
          </template>
          <div
            class="setting-btn"
            :class="{ active: isShowViewer }"
            @click="mutationUpdateIsShowViwer(true)"
          >
            初始视角
          </div>
        </div>
        <el-button size="mini" type="primary" icon="el-icon-s-promotion" @click="toPreview">
          预览
        </el-button>
      </div>
    </div>

    <spot-list v-if="isShowSpotList" :show.sync="isShowSpotList" />
    <spot-add-edit
      v-if="isShowAddEditSpot"
      :id="hotspotId"
      :row="row"
      :show.sync="isShowAddEditSpot"
    />
    <scene-viewer v-if="isShowViewer" />
    <polyline-list v-if="isShowPolylineList" :show.sync="isShowPolylineList" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import build from '../build';
import spotList from './page-header-spot-list';
import spotAddEdit from './page-header-spot-add-edit';
import sceneViewer from './page-header-scene-viewer';
import polylineList from './page-header-polyline-list';
import headerGroup from './page-header-group';

export default {
  components: { spotList, spotAddEdit, sceneViewer, polylineList, headerGroup },

  data() {
    return {
      isShowAddEditSpot: false,
      isShowSpotList: false,
      isShowPolylineList: false,
      isFloorSpot: false,
      hotspotId: '',
      row: null,
      moveDelayTimer: 0, //热点移动delay
      userInfo: this.$store.state.user.userInfo,
      worksType: this.$route.query.type,
    };
  },

  computed: {
    ...mapState('tour', [
      'sceneDetail',
      'krp',
      'materialId',
      'workDetail',
      'groupList',
      'activeGroupId',
      'isShowViewer',
    ]),
  },

  created() {
    window.krpjs.addFloorSpot = this.addFloorSpot;
    window.krpjs.moveFloorHotspot = this.moveFloorHotspot;
    window.krpjs.showFloorSpotEdit = this.showFloorSpotEdit;
    window.krpjs.addEditableHotspotList = this.addEditableHotspotList;
    window.krpjs.moveHotspot = this.moveHotspot;
    window.krpjs.deleteHotSpot = this.deleteHotSpot;
    window.krpjs.editHotSpot = this.editHotSpot;
  },

  methods: {
    ...mapActions('tour', {
      actionGetSceneDetail: 'getSceneDetail',
    }),

    ...mapMutations('tour', {
      mutationUpdateIsShowViwer: 'UPDATE_IS_SHOW_VIWER',
    }),

    showPanel(target) {
      this.isShowSpotList = false;
      this.isShowPolylineList = false;
      this.mutationUpdateIsShowViwer(false);
      this[target] = true;
    },

    //前往预览
    toPreview() {
      let routeData = this.$router.resolve({
        path: '/preview',
        query: { id: this.workDetail.id, subjectId: this.userInfo.subjectInfo.id },
      });
      window.open(routeData.href, '_blank');
    },

    //监听热点移动
    moveHotspot(id, ath, atv) {
      this.moveHotspotTitleAndOPerator(id, ath, atv);
      clearTimeout(this.moveDelayTimer);
      this.moveDelayTimer = setTimeout(async () => {
        try {
          await this.api.spot.updateLocation({ id, ath, atv });
          this.$message.success('位置更新成功');
        } catch (e) {
          console.error(e);
        }
      }, 500);
    },

    moveHotspotTitleAndOPerator(id, ath, atv) {
      let name = `hotspot_${id}`;
      this.krp.call(`set(hotspot[${name}].ath,${ath})`);
      this.krp.call(`set(hotspot[${name}].atv,${atv})`);
    },

    //删除热点
    async deleteHotSpot(id) {
      try {
        await this.$confirm('确认删除?', '提示', { type: 'warning' });
        this.doDeleteHotSpot(id);
      } catch (e) {
        console.error(e);
      }
    },

    async doDeleteHotSpot(id) {
      try {
        await this.api.spot.delete({ id });
        let name = `hotspot_${id}`;
        build.removeHotspots(this.krp, [
          name,
          name + '_placeholder',
          name + '_edit',
          name + '_delete',
          name + '_title',
          name + '_desc',
        ]);
        this.$message.success('删除成功');
        await this.actionGetSceneDetail({ materialId: this.materialId });
      } catch (e) {
        console.error(e);
      }
    },

    //修改热点
    async editHotSpot(id) {
      this.hotspotId = Number(id);
      this.isShowAddEditSpot = true;
    },

    //绘制热点
    addEditableHotspotList() {
      this.sceneDetail.spotList.forEach((item) => {
        item.isMobile = this.isMobile;
        if (
          item.imageType == 1 ||
          item.imageType == 2 ||
          item.imageType == 6 ||
          item.imageType == 7
        ) {
          build.rednerHotspot(this.krp, item);
          build.renderHotspotPlaceholder(this.krp, item);
          build.renderHotspotEdit(this.krp, item);
          build.renderHotspotDelete(this.krp, item);
          item.isShowTitle === 1 && build.renderHotspotTitle(this.krp, item);
        }
        if (item.imageType == 3) {
          build.rednerHotspot(this.krp, item);
        }
        if (item.imageType == 4) {
          build.rednerHotspotText(this.krp, item);
          build.renderHotspotEdit(this.krp, item);
          build.renderHotspotDelete(this.krp, item);
        }
        if (item.imageType == 5) {
          build.rednerHotspot(this.krp, item);
          build.renderHotspotPlaceholder(this.krp, item);
          build.renderHotspotEdit(this.krp, item);
          build.renderHotspotDelete(this.krp, item);
          item.isShowTitle === 1 && build.renderHotspotTitle(this.krp, item);
          build.renderHotspotDesc(this.krp, item);
        }
      });
      this.sceneDetail.pointList.forEach((item, index) => {
        build.renderPolyline(this.krp, item, index);
      });
    },

    //切换是否添加地板热点模式
    openFloorSpot() {
      this.isFloorSpot = true;
      this.krp.call(`set(hotspot[floorspot].visible,true))`);
    },

    //添加地板热点
    addFloorSpot(tx, ty, tz, ry) {
      this.hotspotId = 0;
      this.row = {
        ath: 0,
        atv: 0,
        imageType: 3,
        opacity: 0.7,
        scale: 0.1,
        mScale: 0.1,
        width: 200,
        height: 200,
        image: '4e53bf6c_0a61_4d2b_9cf0_26efbd4e712a1640587454563',
        imagePreview: 'https://vybbasevr.vyb.cn/4e53bf6c_0a61_4d2b_9cf0_26efbd4e712a1640587454563',
        ext: {
          tx,
          ty,
          tz,
          ry,
          distorted: true,
          depth: 0,
          rx: '-90',
          rotationorder: 'xyz',
          bgcolor: '0xFFFFFF',
          bgroundedge: 50,
        },
      };
      this.isShowAddEditSpot = true;
      this.isFloorSpot = false;
      this.krp.call(`set(hotspot[floorspot].visible,false))`);
    },

    moveFloorHotspot(id, tx, ty, tz) {
      clearTimeout(this.moveDelayTimer);
      this.moveDelayTimer = setTimeout(async () => {
        try {
          let res = await this.api.spot.getSpotInfo({ id });
          await this.api.spot.updateLocation({
            id,
            ath: 0,
            atv: 0,
            ext: Object.assign(res.data.ext, { tx, ty, tz }),
          });
          this.$message.success('位置更新成功');
        } catch (e) {
          console.error(e);
        }
      }, 500);
    },
  },
};
</script>

<style scoped>
.v-page-header {
  display: flex;
  margin: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
  border: 0;
  color: #fff;
  box-sizing: border-box;
  height: 52px;
  justify-content: space-between;
  align-items: center;
  transform: translateZ(1px);
  padding-left: 0;
}

.v-page-header .work-name {
  width: 154px;
  text-align: center;
}

.v-page-header .header-right {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.setting-box {
  display: flex;
  align-items: center;
}

.setting-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 0 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
  margin-right: 10px;
  border: 1px solid #929292;
}

.setting-btn.active {
  color: rgba(30, 159, 255, 1);
  border-color: rgba(30, 159, 255, 1);
}

.setting-btn >>> .el-loading-spinner {
  margin-top: -7px;
}

.setting-btn >>> .el-loading-spinner .el-icon-loading {
  color: #fff;
}
</style>
